import Slideshow from '../components/slideshow.js';

export default function Home() {
  return (
    <>
        
      <Slideshow/>
      {/* <div class="description"> */}
        <p>
          Freshwater shrimp are a passion of mine, especially Caridina. Caridina 
          have a reputation of being difficult to keep, but like anything else with 
          practice are relatively simple. Please checkout the care page and if
          you have any additional questions on shrimp care feel free to contact me. 
        </p>
      {/* </div> */}
        <p>
          Unfortunately at this time we only offer local pickup.
        </p>
        <p>
          This site was developed personally by me after completing a coding bootcamp course. 
          Feel free to contact me with any constructive criticism.
        </p>
    </>
  )
}
